import {
  AlertWarningIcon,
  Box,
  Button,
  Typography,
  useMobileBreakpoint,
} from '@customink/pigment-react';

type EditGroupSizesFormActionsProps = {
  formId: string;
  isUpdating: boolean;
  totalQuantity: number;
  minQuantity?: number;
  compact?: boolean;
  onClose: () => void;
};

export function EditGroupSizesFormActions({
  formId,
  isUpdating,
  totalQuantity,
  minQuantity,
  compact,
  onClose,
}: EditGroupSizesFormActionsProps) {
  const isMobile = useMobileBreakpoint();

  return (
    <>
      <Box
        display="flex"
        flexDirection={compact ? 'row' : 'column'}
        flexWrap="wrap"
        gap={isMobile ? '0.5rem' : '0.125rem'}
        justifyContent={compact ? 'space-between' : undefined}
        width={compact ? '100%' : 'auto'}
      >
        <Typography variant="uiTextDefault">
          Total Quantity: {totalQuantity}
        </Typography>

        {minQuantity && totalQuantity < minQuantity && (
          <Box
            alignItems="center"
            color="#A86800"
            display="flex"
            flexDirection="row"
            gap="0.25rem"
          >
            <AlertWarningIcon sx={{ fontSize: '1rem' }} />
            <Typography variant="uiTextSmall">
              Minimum needed: {minQuantity}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        gap="0.5rem"
        // There's an override that sets the left margin to 0 for the last item in the DialogActions
        // so we need to override it here
        ml="0 !important"
        width={isMobile ? '100%' : 'auto'}
      >
        <Button
          data-testid="modal-close-button"
          onClick={onClose}
          size="large"
          sx={{ flex: isMobile ? 1 : 'initial' }}
          variant="secondary"
        >
          Close
        </Button>
        <Button
          disabled={isUpdating}
          form={formId}
          size="large"
          sx={{ flex: isMobile ? 1 : 'initial' }}
          type="submit"
          variant="primary"
        >
          Update
        </Button>
      </Box>
    </>
  );
}
